import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AddToProductComponent } from 'src/app/barcode/add-to-product/add-to-product.component';
import { NotificationService } from 'src/app/services/notification.service';
import { SupportService } from 'src/app/support.service';
import { Product, Warehouse } from 'src/typings';
import { WarehouseService } from 'src/app/warehouse/warehouse.service';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-product-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit, OnChanges {
  @Input() product: Product | null = null;

  @Input() defaultWarehouse: Warehouse | null = null;

  @Output() updateProductEvent = new EventEmitter<Product>();

  constructor(
    public supportService: SupportService,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private productService: ProductService,
    private warehouseService: WarehouseService,
    private notificaitonService: NotificationService
  ) {}

  cellFormControl = new UntypedFormControl();

  updateForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl(),
    brand: new UntypedFormControl(),
    barcode: new UntypedFormControl(),
    article: new UntypedFormControl(),
    retail: new UntypedFormControl(),
    folder: new UntypedFormControl()
  });

  get brandControl() {
    return this.updateForm.controls.brand as UntypedFormControl;
  }

  get folderControl() {
    return this.updateForm.controls.folder as UntypedFormControl;
  }

  ngOnInit(): void {
    this.checkRequiredFields(this.product);
  }

  deleteBarcode(barcode: string) {
    if (this.product) {
      this.productService
        .removeBarcodeToProduct({
          product_id: this.product.id,
          barcode
        })
        .subscribe((list) => {
          if (this.product) this.product.barcodes = list;
        });
    }
  }

  save() {
    // @todo реализовать или удалить
  }

  addBarcode() {
    const dialogRef = this.dialog.open(AddToProductComponent);
    if (this.product) {
      dialogRef.componentInstance.product = this.product;
      dialogRef.componentInstance.dialog = dialogRef;
    }
  }

  ngOnChanges(changes: any) {
    const product = changes.product?.currentValue as Product;
    const defaultWarehouse = changes.defaultWarehouse?.currentValue as Warehouse;
    if (product) {
      this.updateForm.controls?.description.setValue(product?.description);
      this.updateForm.controls?.article.setValue(product?.article);
      this.updateForm.controls?.brand.setValue(product?.brand);
      this.updateForm.controls?.barcode.setValue(product?.barcode);
      this.updateForm.controls?.retail.setValue(product?.retail);
      this.updateForm.controls?.folder.setValue(product?.folder);
    }
    if (product && defaultWarehouse) {
      this.updateForm.controls?.description.setValue(product?.description);
      this.updateForm.controls?.article.setValue(product?.article);
      this.updateForm.controls?.brand.setValue(product?.brand);
      this.updateForm.controls?.barcode.setValue(product?.barcode);
      this.updateForm.controls?.retail.setValue(product?.retail);
      this.cellFormControl.setValue(
        product?.stock.find((wh) => wh.warehouse.id === defaultWarehouse.id)?.cell
      );
    }
    if (defaultWarehouse) {
      this.cellFormControl.setValue(
        this.product?.stock.find((wh) => wh.warehouse.id === defaultWarehouse.id)?.cell
      );
    }
    this.checkRequiredFields(this.product);
  }

  checkRequiredFields(input: Product | null) {
    if (input === null) {
      throw new Error("Attribute 'product' is required");
    }
  }

  deleteProduct() {
    if (this.product) {
      this.productService.deleteProduct(this.product.id).subscribe(() => {
        this.notificaitonService.notice('Товар успешно удален!');
        this.updateProductEvent.emit();
      });
    } else {
      this.notificaitonService.warning('Ошибка при удалении товара!');
    }
  }
}
